import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AttachmentsValueModel } from 'projects/shared/src/models/AttachmentsValueModel';
import { UserDetails } from 'projects/shared/src/models/users/UserDetails';
import { UserProfileService } from 'projects/shared/src/services/user-profile.service';

@Component({
  selector: 'app-trainer-details',
  templateUrl: './trainer-details.component.html',
  standalone: false
})
export class TrainerDetailsComponent implements OnInit {
  @Input() trainerId: string;
  @Output() closeDetails = new EventEmitter<boolean>();
  dataLoading = false;
  details: UserDetails = new UserDetails();

  openSideNav: boolean;
  selectedAttachment: AttachmentsValueModel;

  constructor(
    private service: UserProfileService
  ) { }

  ngOnInit() {
    this.getDetails();
  }

  getDetails() {
    this.dataLoading = true;
    this.service.getTrainerBio(this.trainerId).subscribe(
      data => {
        this.dataLoading = false;
        if (data) {
          this.details = data as UserDetails;
        }
      },
      error => {
        this.dataLoading = false;
      });
  }

  openSidenav(attachment: AttachmentsValueModel) {
    this.selectedAttachment = attachment;
    this.openSideNav = true;
  }

  closeSidenav(e) {
    this.openSideNav = false;
  }

}
